import React from 'react'
import Image from 'next/image'
import clockImg from 'assets/icons/common/clock.svg'
import Tag from '../tag'
import {format} from 'date-fns'
import parse from 'html-react-parser'
import classes from './styles.module.css'

const BlogCard = ({
  blog,
  getBlogReadingTime,
}: {
  blog: any
  getBlogReadingTime: (string: string) => string
}) => {
  function normalizeMinutesLabel(input: string): string {
    if (input.includes('minutes')) {
      return input.replace(/minutes/g, 'mins.')
    }
    if (input.includes('minute')) {
      return input.replace(/minute/g, 'min.')
    }
    return input
  }
  return (
    <div className={classes.blog}>
      {' '}
      {/* Add this class to the outer div */}
      <div className={classes.image}>
        <Image
          priority
          src={
            blog?.jetpack_featured_media_url ||
            blog?._embedded?.self?.[0]?.jetpack_featured_media_url
          }
          alt="blog"
          width={426}
          height={240}
        />
      </div>
      <div className={classes.info}>
        <div className={classes.contentArea}>
          {' '}
          {/* Add this wrapper div */}
          <div className={classes.tags}>
            {((blog?._embedded['wp:term'] && blog?._embedded['wp:term'][0]) || []).map(
              (tag: {slug: string; name: string}) =>
                tag.name !== 'Recommended' ? (
                  <Tag key={tag?.slug} text={tag.name} slug={tag?.slug} />
                ) : null,
            )}
          </div>
          <p className={classes.title}>
            {parse(
              blog.title.rendered || blog?._embedded?.self?.[0]?.title?.rendered || 'No Title',
            )}
          </p>
        </div>
        <div className={classes.cardFooter}>
          <div className={classes.authorAndDate}>
            {blog?.date || blog?._embedded.self[0]?.date
              ? format(new Date(blog?.date || blog?._embedded.self[0]?.date), 'dd MMM, yyyy')
              : ''}
          </div>
          <div className={classes.time}>
            <Image src={clockImg} width={18} className={classes.clockImage} alt="" />
            <div>{`${
              normalizeMinutesLabel(getBlogReadingTime(blog?.content?.rendered)) || '4 mins.'
            }`}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BlogCard
